module.exports = "https://preprod.web-phone.apps.phone.com/static/media/dtmf-9.426be99c.mp3";